import { Card, Button } from '@heroui/react'
import { Check } from 'lucide-react'

export interface PricingCardProps {
  title: string
  price: string
  duration: string
  features: string[]
  isPopular?: boolean
  popularText?: string
  buttonText?: string
  processingText?: string
  onSubscribe: () => void
  isLoading?: boolean
}

export function PricingCard({
  title,
  price,
  duration,
  features,
  isPopular,
  popularText = 'Most Popular',
  buttonText = 'Subscribe',
  processingText = 'Processing...',
  onSubscribe,
  isLoading,
}: PricingCardProps) {
  return (
    <Card className={`relative flex flex-col p-6 h-full ${isPopular ? 'border-primary border-2' : ''}`}>
      {isPopular && (
        <div className="absolute top-0 right-0 bg-primary text-primary-foreground px-3 py-1 rounded-bl-lg rounded-tr-lg text-sm font-medium">
          {popularText}
        </div>
      )}
      <div className="mb-6">
        <h3 className="text-xl font-bold mb-2">{title}</h3>
        <div className="flex items-baseline gap-1">
          <span className="text-4xl font-extrabold">{price}</span>
          <span className="text-muted-foreground text-sm">{duration}</span>
        </div>
      </div>
      
      <div className="flex-1 space-y-4 mb-6">
        {features.map((feature, i) => (
          <div key={i} className="flex items-start gap-3 text-sm">
            <Check className="w-5 h-5 text-primary shrink-0" />
            <span>{feature}</span>
          </div>
        ))}
      </div>

      <Button
        variant={isPopular ? 'primary' : 'outline'}
        className="w-full mt-auto"
        onPress={onSubscribe}
        isDisabled={isLoading}
      >
        {isLoading ? processingText : buttonText}
      </Button>
    </Card>
  )
}
